(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.form = {
    attach: function (context, settings) {
      $(once("form", ".form", context))
        .each(function (i, form) {
          bindFormEvents($(form));
        });

      function pushContactData(eventCategoryName, checkbox, topic) {
        pushData({
          event: "ga-event",
          eventCategory: `${eventCategoryName}`,
          eventAction: `${
            checkbox ? "With subscription" : "Without subscription"
          }`,
          eventLabel: `${topic}`,
          eventValue: undefined,
          nonInteraction: false,
        });
      }

      function bindFormEvents(form) {
        const $requiredFields = form.find(".required-field");
        const $requiredCheckboxes = form.find(".required-checkbox");
        const $requiredRadio = form.find(".required-radio");
        const $hoverFields = form.find(
          ".js-form-input, .js-select2, .js-form-textarea"
        );
        const $autofillInputs = form.find(".js-form-row-autofill-additional");
        const $autofillMore = form.find(".js-autofill-more");
        const $newsletterCheckbox = form.find(
          ".js-marked-as-newsletter-for-analytics"
        );
        const $topic = form.find(".js-marked-as-topic-for-analytics");
        const $eventCategoryName = form.data("category");
        const $formBtn = form.find(".js-submit-contact-btn");
        $formBtn.on("click", function (e) {
          const isInvalid = validateFields(
            $requiredFields,
            $requiredCheckboxes,
            $requiredRadio
          );
          if (isInvalid) {
            if ($autofillInputs) {
              showMore();
            }
            $("#loader").addClass("hidden");

            return e.preventDefault();
          } else {
            e.preventDefault();
            const _continue = function(form) {
              $("#loader").removeClass("hidden");
              const contactTrackId = $(".js-field-gatrackid", context);
              const contactClientId = $(".js-field-gaclientid", context);
              const contactUserCat = $(".js-field-gausercat", context);
              const contactUserId = $(".js-field-gauserid", context);

              if (typeof ga !== 'undefined') {
                ga(() => {
                  const gaCont = ga.getAll()[0];
                  const clientId = gaCont.get("clientId") || "undefined";
                  const trackId = gaCont.get("trackingId") || "undefined";
                  const userCat = gaCont.get("userCategory") || "undefined";
                  const userId = gaCont.get("userCategory") || "undefined";

                  if (contactTrackId.length) {
                    contactTrackId.each(function (index, input) {
                      input.value = trackId;
                    });
                  }

                  if (contactClientId.length) {
                    contactClientId.each(function (index, input) {
                      input.value = clientId;
                    });
                  }

                  if (contactUserCat.length) {
                    contactUserCat.each(function (index, input) {
                      input.value = userCat;
                    });
                  }

                  if (contactUserId.length) {
                    contactUserId.each(function (index, input) {
                      input.value = userId;
                    });
                  }
                });
              }

              const utmSource = $(".js-field-utm-source", context);
              const utmMedium = $(".js-field-utm-medium", context);
              const utmCampaign = $(".js-field-utm-campaign", context);
              const utmContent = $(".js-field-utm-content", context);
              const utmTerm = $(".js-field-utm-term", context);

              function getCookie(name) {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) return parts.pop().split(";").shift();
              }

              const sourceVal = getCookie("utmsource") || "undefined";
              const mediumVal = getCookie("utmmedium") || "undefined";
              const campaignVal = getCookie("utmcampaign") || "undefined";
              const contentVal = getCookie("utmcontent") || "undefined";
              const termVal = getCookie("utmterm") || "undefined";

              if (utmSource.length) {
                utmSource.each(function (index, input) {
                  input.value = sourceVal;
                });
              }
              if (utmMedium.length) {
                utmMedium.each(function (index, input) {
                  input.value = mediumVal;
                });
              }
              if (utmCampaign.length) {
                utmCampaign.each(function (index, input) {
                  input.value = campaignVal;
                });
              }
              if (utmContent.length) {
                utmContent.each(function (index, input) {
                  input.value = contentVal;
                });
              }
              if (utmTerm.length) {
                utmTerm.each(function (index, input) {
                  input.value = termVal;
                });
              }

              pushContactData(
                $eventCategoryName,
                $newsletterCheckbox.is(":checked") || false,
                $topic.val() || undefined
              );
              form.find('.js-form')[0].submit();
            }

            if (document.getElementById('h-captcha-sitekey-popup').value) {
              const key = document.getElementById('h-captcha-sitekey-popup').value;
              console.log('Setting up hCaptcha for form index: webform');
              const g = document.createElement('div');
              g.className = 'captcha_widget-id';
              form.append(g);
              console.log('hCaptcha container added to the form. webform');
              const _widgetID = hcaptcha.render(g, {
                size: 'invisible',
                sitekey: key,
                callback: function(response) {
                  hcaptchaSetHCFieldWebform(response, form);
                }.bind(form)
              });
              console.log('widget2:', _widgetID);
              console.log('Form submit intercepted for form index: webform');
              hcaptcha.execute(_widgetID); // Execute the hCaptcha
              console.log('hCaptcha execute called for widget ID:', _widgetID);
              const hcaptchaSetHCFieldWebform = function(response, form) {
                console.log('hCaptcha token received: webform', response);
                window.havePasscode = true;
                window.curPasscode = response;
                const response_placeholder = form[0].getElementsByClassName('js-hcaptcha-token');
                if (response_placeholder) response_placeholder[0].value = response;
                console.log('hCaptcha token set in form: webform');
                _continue(form);
              };
            } else {
              _continue(form);
            }

          }
        });
        $requiredFields.blur((e) => {
          validateReqFields($(e.target));
        });
        $hoverFields.blur((e) => {
          handleFocus(e, $(e.target));
        });
        $hoverFields.focus((e) => {
          handleFocus(e, $(e.target));
        });
        $requiredRadio.each((index, radio) => {
          const $buttons = $(radio).find(".js-radio-button");
          $buttons.blur(() => {
            validateReqRadio($(radio));
          });
        });
        $requiredCheckboxes.blur((e) => {
          validateReqCheckbox($(e.target));
        });
        $requiredCheckboxes.click((e) => {
          validateReqCheckbox($(e.target));
        });

        function validateFields(
          $requiredFields,
          $requiredCheckboxes,
          $requiredRadio
        ) {
          if ($requiredFields.length) {
            validateReqFields($requiredFields);
          }
          if ($requiredCheckboxes.length) {
            validateReqCheckbox($requiredCheckboxes);
          }
          if ($requiredRadio.length) {
            validateReqRadio($requiredRadio);
          }
          return [
            ...$requiredFields.toArray(),
            ...$requiredCheckboxes.toArray(),
            ...$requiredRadio.toArray(),
          ].some((field) => field.classList.contains("is-empty"));
        }
        function validateReqFields($requiredFields) {
          $requiredFields.each((index, field) => {
            const $parent = $(field).closest(".js-form-row");
            const $errorField = $parent.find(".js-field-error");
            if (field.value.trim() === "") {
              field.classList.add("is-empty");
              field.classList.remove("not-empty");
              if ($errorField) {
                $errorField.text($errorField.data("empty"));
              }
            } else {
              field.classList.add("not-empty");
              field.classList.remove("is-empty");
              if ($errorField) {
                $errorField.text("");
              }
              if (field.getAttribute("type") === "email") {
                if (!validateEmail(field)) {
                  field.classList.remove("not-empty");
                  field.classList.add("is-empty");
                  if ($errorField) {
                    $errorField.text($errorField.data("invalid"));
                  }
                }
                const flag = $parent.data('emailBlocking');
                if (flag === 1) {
                  const emailDomainsArray = $parent.data('emailDomains').length ? $parent.data('emailDomains').split('|') : '';
                  const emailDomainError = $errorField.data('blocked').length ? $errorField.data('blocked') : '';
                  const mailProvider = field.value.split('@').pop().split('.')[0];
                  if (emailDomainsArray.includes(mailProvider)) {
                    field.classList.add("is-empty");
                    field.classList.remove("not-empty");
                    $errorField.text(emailDomainError);
                  }
                }
              }
              if (field.getAttribute("type") === "tel") {
                if (!validateTel(field)) {
                  field.classList.remove("not-empty");
                  field.classList.add("is-empty");
                  if ($errorField) {
                    $errorField.text($errorField.data("invalid"));
                  }
                }
              }
            }
          });
        }
        function validateReqCheckbox($requiredCheckboxes) {
          $requiredCheckboxes.each((index, checkbox) => {
            const $parent = $(checkbox).closest(".js-form-row");
            const $errorField = $parent.find(".js-field-error");
            if (!checkbox.checked) {
              if ($errorField) {
                $errorField.text($errorField.data("empty"));
              }
              checkbox.classList.add("is-empty");
            } else {
              checkbox.classList.remove("is-empty");
              $errorField.text("");
            }
          });
        }
        function validateReqRadio($requiredRadio) {
          $requiredRadio.each((index, radio) => {
            const $buttons = $(radio).find(".js-radio-button");
            const $errorField = $(radio).find(".js-field-error");
            const anyChecked = $buttons
              .toArray()
              .some((radio) => radio.checked);
            if (!anyChecked) {
              radio.classList.add("is-empty");
              $errorField.text($errorField.data("empty"));
            } else {
              radio.classList.remove("is-empty");
              $errorField.text("");
            }
          });
        }
        function validateEmail(field) {
          const re = /[a-zA-Z0-9+-_%.]+@[a-zA-Z0-9_-]+\.[A-Za-z0-9]{2,64}/;
          return re.test(field.value);
        }
        function validateTel(field) {
          const re =
            /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i;
          return re.test(field.value);
        }
        function handleFocus(e, field) {
          const parent = field.closest(".js-form-row");
          if (typeof e.type !== "undefined" && e.type === "focus") {
            parent.addClass("has-focus");
            return;
          }
          if (field.val().trim() === "") {
            parent.removeClass("has-focus");
          } else {
            parent.addClass("has-focus");
          }
        }
        function showMore() {
          $autofillMore.addClass("hide");
          $autofillInputs.addClass("show");
        }
      }
    },
  };
})(jQuery, Drupal, once);
